import { render, staticRenderFns } from "./EditPacker.vue?vue&type=template&id=8076d3b4"
import script from "./EditPacker.vue?vue&type=script&lang=js"
export * from "./EditPacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports